import React, { useState } from "react";
import { BsFacebook, BsInstagram, BsTwitterX, BsYoutube } from "react-icons/bs";
import { Link } from "react-router-dom";
import { subscribeEmail } from "../../../services/api";
import toast from "react-hot-toast";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate email
    if (!email.trim()) {
      toast.error("Please enter an email address");
      return;
    }
    
    if (!validateEmail(email)) {
      toast.error("Please enter a valid email address");
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const response = await subscribeEmail(email);
      toast.success("Thank you for subscribing!");
      setEmail(""); // Clear the input field
    } catch (error) {
      toast.error(error.message || "Failed to subscribe. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="public-footer text-white px-6 pt-12 pb-8">
      <div className="container mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12">
          {/* Logo and Description Column - 3/12 */}
          <div className="col-span-1 md:col-span-3">
            <img
              src="/imgs/logo.png"
              alt="Tabletop Recorder"
              className="mb-4 h-16"
            />
            <p className="text-sm">
            No TTRPG player should have to choose between staying immersed in the moment or being the record keeper for the campaign. Every session, everyone adventures and socializes together.
            </p>
          </div>

          {/* Quick Links and Follow Us Container - 3/12 total */}
          <div className="col-span-1 md:col-span-3">
            <div className="grid grid-cols-2 gap-4">
              {/* Quick Links Column - 1/2 of container */}
              <div className="col-span-1">
                <h3 className="text-lg font-semibold mb-4">QUICK LINKS</h3>
                <ul className="space-y-2">
                  <li>
                    <Link to="/" className="hover:text-gray-300">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/register" className="hover:text-gray-300">
                      Registration
                    </Link>
                  </li>
                  <li>
                    <Link to="/login" className="hover:text-gray-300">
                      Sign in
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Follow Us Column - 1/2 of container */}
              <div className="col-span-1">
                <h3 className="text-lg font-semibold mb-4">FOLLOW US</h3>
                {/* Social Media Icons */}
                <div className="flex space-x-4 mb-6">
                  <a
                    href="https://www.facebook.com/profile.php?id=61571374963959"
                    className="hover:text-gray-300">
                    <BsFacebook size={20} />
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Subscribe Form Column - 6/12 */}
          <div className="col-span-1 md:col-span-6 flex flex-col">
            <h3 className="text-lg font-semibold mb-4">Subscribe to our Newsletter</h3>
            <form onSubmit={handleSubmit} className="flex flex-row">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-grow px-4 py-2 bg-white text-slate-900 rounded-l-lg focus:outline-none"
                value={email}
                onChange={handleEmailChange}
                disabled={isSubmitting}
              />
              <button 
                type="submit"
                className={`${
                  isSubmitting 
                    ? 'bg-gray-500' 
                    : 'bg-primary hover:bg-primary-light'
                } px-6 py-2 rounded-r-lg whitespace-nowrap transition-colors`}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Subscribing...' : 'Subscribe'}
              </button>
            </form>
          </div>
        </div>

        {/* Horizontal Line */}
        <hr className="my-8 border-white" />

        {/* Copyright */}
        <div className="pt-2 text-center text-sm">
          Copyright © 2024 Tabletop Recorder. All rights reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;
